import {Component, OnDestroy, OnInit} from '@angular/core';
import {FormControl, FormGroup} from '@angular/forms';
import {Observable} from 'rxjs';
import {Store} from '@ngrx/store';
import * as fromStore from '../../../store';
import {Website} from '../website';
import {ActivatedRoute} from '@angular/router';
import {Subscription} from 'rxjs';
import {DialogService} from "../../../../ng2-bootstrap-modal/dialog.service";
import {RestoreSecurityIssueDialogComponent} from "./restore-security-issue-dialog/restore-security-issue-dialog.component";
import {SecurityIssue} from "./security-issue";
import {SecurityVulnerability} from "./security-vulnerability";
import {SecurityIgnoredIssue} from "./security-ignored-issue";
import {SecurityService} from "./security.service";
import {DbResponse} from "../../../shared/interceptors/db-response";
import {Notification} from "../../../shared/components/notifier/notification";
import {NotificationType} from "../../../shared/components/notifier/notification-type";
import {NotifierComponent} from "../../../shared/components/notifier/notifier.component";
import {filter, first, map, switchMap} from 'rxjs/operators';
import {ActivityAction, IActivity} from '../../../activities/activity';
import {Product} from '../product';
import {UserSubscription} from "../../../user/user-subscription";
import {animate, style, transition, trigger} from '@angular/animations';
import {User} from "../../../user/user";
import * as securityAction from "../../../store/actions/security.action";

@Component({
    selector: 'db-security',
    templateUrl: './security.component.html',
    styleUrls: ['./security.component.scss'],
    animations: [
        trigger('issueAnimation', [
            transition("void => true", [
                style({
                    maxHeight: '0',
                    overflow: 'hidden'
                }),
                animate('500ms', style({
                    maxHeight: '200px',
                    overflow: 'hidden'
                })),
            ]),
            transition('true => void', [
                style({
                    maxHeight: '200px',
                    overflow: 'hidden'
                }),
                animate('500ms', style({
                    maxHeight: '0',
                    overflow: 'hidden'
                })),
            ]),
        ]),
    ],
    standalone: false
})
export class SecurityComponent implements OnInit, OnDestroy {

  private _subscriptions: Subscription[];
  public scheduleEnabled: any;
  public scheduleSettings: any;
  public scheduleCronExpression: string;
  public securityScheduleLoading: boolean;

  public isManagable: boolean;
  public loading: boolean;

  public userSubscriptoin: UserSubscription;
  public website: Website;
  public securityPlugin: Product;

  public ongoingActivity$: Observable<IActivity>;

  public securityScanRunning$: Observable<boolean>;
  public securityIssues$: Observable<SecurityIssue[]>;
  public securityIssues: SecurityIssue[];
  public securityIgnoredIssues: SecurityIgnoredIssue[];
  public securityIssuesLength$: Observable<number>;
  public securityVulnerabilities$: Observable<SecurityVulnerability[]>;
  public securityVulnerabilitiesLength$: Observable<number>;
  public securityIgnoredIssues$: Observable<SecurityIgnoredIssue[]>;

  public securitySettingsLoading$: Observable<boolean>;
  public securityScheduleLoading$: Observable<boolean>;

  public ignoringIssueFilePaths: string[];
  public restoringIssueIds: string[];

  public activeTab: FormControl;

  public securitySettingsFg: FormGroup;
  /*public wordpressVulnerabilitiesFc: FormControl;
  public pluginsVulnerabilitiesFc: FormControl;*/
  public coreFilesChangesFc: FormControl;
  public pluginFilesChangesFc: FormControl;
  public themeFilesChangesFc: FormControl;
  public autoUpdateProductsFc: any;
  public hasHostingBanner: any;
  public user: User;
  public securityAutoupdateLoading: boolean;
  public selectAll: FormControl;
  public bulkRestoreLoading: boolean;
  public bulkIgnoreLoading: boolean;
  public _childWebsiteId: number;
  public firstInfoLink: string = "https://help.10web.io/hc/en-us/articles/360016175132-Setting-up-10Web-Security-service";


  constructor(
    private _route: ActivatedRoute,
    private _store: Store<fromStore.DbStoreState>,
    private _dialogService: DialogService,
    private _securityService: SecurityService
  ) {
    this.selectAll = new FormControl("");
    this.initSettingsForm();
  }

  private initSettingsForm() {
    /*this.wordpressVulnerabilitiesFc = new FormControl(false);
    this.pluginsVulnerabilitiesFc = new FormControl(false);*/
    this.coreFilesChangesFc = new FormControl(false);
    this.pluginFilesChangesFc = new FormControl(false);
    this.themeFilesChangesFc = new FormControl(false);

    this.securitySettingsFg = new FormGroup({
      /*'wordpressVulnerabilities': this.wordpressVulnerabilitiesFc,
      'pluginsVulnerabilities': this.pluginsVulnerabilitiesFc,*/
      'coreFilesChanges': this.coreFilesChangesFc,
      'pluginFilesChanges': this.pluginFilesChangesFc,
      'themeFilesChanges': this.themeFilesChangesFc,
    });
  }

  ngOnInit() {
    this.user = this._route.snapshot.parent.data['user'];
    this.hasHostingBanner = localStorage.getItem("showConnectBanner" + this.user.id);
    this.userSubscriptoin = this._route.snapshot.parent.data['userSubscription'];
    this.website = this._route.snapshot.parent.data['website'];
    this._childWebsiteId = this.website.isNetwork && !this.website.parentId && this.website.children && this.website.children.length ? this.website.children[0] : null;

    this.securityPlugin = this._route.snapshot.data['securityPlugin'];
    this.isManagable = !this.website.isLocalhost && this._route.snapshot.parent.data['user'].permissions.canManageContent;

    this.ongoingActivity$ = this._store.select(fromStore.getSecurityOngoingActivity(this._childWebsiteId || this.website.id));
    this.ongoingActivity$.subscribe((activity) => {
      if (activity) {
        if (activity.status === 'done' || activity.status === 'failed') {
          this.loading = false;
        }
        else {
          this.loading = true;
        }
      }
    });

    this.securityScanRunning$ = this._store.select(fromStore.getSecurityScanRunning(this._childWebsiteId || this.website.id));
    this.securityIssues$ = this._store.select(fromStore.getSecurityScanIssues(this._childWebsiteId || this.website.id));
    this.securityIssues$.subscribe((securityIssues): void => {
        if (securityIssues) {
          this.securityIssues = securityIssues;
        }
        else {
          this.securityIssues = null;
        }
      });
    this.securityIssuesLength$ = this.securityIssues$.pipe(map((securityIssues: SecurityIssue[]): number => {
      return securityIssues ? securityIssues.length : 0;
    }));


    this.securityVulnerabilities$ = this._store.select(fromStore.getSecurityScanVulnerabilities(this._childWebsiteId || this.website.id));
    this.securityVulnerabilitiesLength$ = this.securityVulnerabilities$.pipe(map((securityVulnerabilities: SecurityVulnerability[]): number => {
      return securityVulnerabilities ? securityVulnerabilities.length : 0;
    }));

    this.securityIgnoredIssues$ = this._store.select(fromStore.getSecurityIgnoredIssues(this._childWebsiteId || this.website.id));
    this.securityIgnoredIssues$.subscribe((securityIgnoredIssues): void => {
      if (securityIgnoredIssues) {
        this.securityIgnoredIssues = securityIgnoredIssues;
      }
      else {
        this.securityIssues = null;
      }
    });
    this.securityIssuesLength$ = this.securityIssues$.pipe(map((securityIssues: SecurityIssue[]): number => {
      return securityIssues ? securityIssues.length : 0;
    }));
    this.securitySettingsLoading$ = this._store.select(fromStore.getSecuritySettingsLoading(this._childWebsiteId || this.website.id));

    this.securityScheduleLoading$ = this._store.select(fromStore.getSecurityScheduleLoading(this._childWebsiteId || this.website.id));

    this.ignoringIssueFilePaths = [];
    this.restoringIssueIds = [];

    this.activeTab = new FormControl('issues');

    this.addSubscriptions();
  }

  private addSubscriptions(): void {
    this._subscriptions = [];

    this._subscriptions.push(
      this._store.select(fromStore.getWebsiteSecurityPlugin(this._childWebsiteId || this.website.id))
        .subscribe((securityPlugin: Product) => {
          this.securityPlugin = securityPlugin;
        })
    );

    this._subscriptions.push(
      this._store.select(fromStore.getSecuritySettingsLoaded(this._childWebsiteId || this.website.id))
        .pipe(
          switchMap(() => {
            return this._store.select(fromStore.getSecuritySettings(this._childWebsiteId || this.website.id))
              .pipe(
                filter((settings): boolean => !!settings),
                first()
              );
          })
        )
        .subscribe((settings) => {
          this.securitySettingsFg.setValue(settings, {
            emitEvent: false
          });
        })
    );

    this._subscriptions.push(
      this._store.select(fromStore.getSecurityScheduleLoaded(this._childWebsiteId || this.website.id))
        .pipe(
          switchMap(() => {
            return this._store.select(fromStore.getSecuritySchedule(this._childWebsiteId || this.website.id))
              .pipe(
                filter((settings): boolean => !!settings),
                first()
              );
          })
        )
        .subscribe((settings) => {
          this.securityScheduleLoading = false;
          this.scheduleSettings = settings;
          this.scheduleEnabled = settings.schedule;
        })
    );

    this._subscriptions.push(
      this._store.select(fromStore.getSecurityAutoupdateLoaded(this._childWebsiteId || this.website.id))
        .pipe(
          switchMap(() => {
            return this._store.select(fromStore.getSecurityAutoupdate(this._childWebsiteId || this.website.id))
              .pipe(
                filter((settings): boolean => !!settings),
                first()
              );
          })
        )
        .subscribe((settings) => {
          this.securityAutoupdateLoading = false;
          this.autoUpdateProductsFc = settings.updateVulnerable;
        })
    );

    this._subscriptions.push(
      this.securitySettingsFg.valueChanges.subscribe((value) => {
        this.updateSettings();
      })
    );
  }

  ngOnDestroy() {
    this.removeSubscriptions();
  }

  private removeSubscriptions(): void {
    this._subscriptions.forEach((subscription: Subscription): void => {
      subscription.unsubscribe();
    });
    this._subscriptions = null;
  }

  public enableScheduling(value) {
    this.scheduleEnabled = value.currentTarget.checked;
  }

  public enableAutoUpdate(value) {
    this.autoUpdateProductsFc = value.currentTarget.checked;
    this.updateSettingsAutoupdate();
  }

  public onActiveTabChange($event: any): void {
    this.updateSelectAllState($event.tabId);
    this.activeTab.setValue($event.tabId, {
      emitEvent: false
    });
  }

  public runScan(): void {
    this._store.dispatch(new fromStore.RunSecurityScan(this._childWebsiteId || this.website.id));
  }

  public restoreFile(securityIssue: SecurityIssue): void {
    this._dialogService
      .addDialog(RestoreSecurityIssueDialogComponent, {
        website: this.website,
        securityIssue: securityIssue
      });
  }

  public ignoreIssue(securityIssue: SecurityIssue): void {
    this.ignoringIssueFilePaths.push(securityIssue.file_path);

    this._securityService.ignoreIssue(this._childWebsiteId || this.website.id, securityIssue)
    .pipe(filter((response: DbResponse): boolean => !!response),
      first())
      .subscribe((response: DbResponse): void => {
        if (this.ignoringIssueFilePaths.includes(securityIssue.file_path)) {
          this.ignoringIssueFilePaths.splice(this.ignoringIssueFilePaths.indexOf(securityIssue.file_path), 1);
        }

        if (response.success) {
          this._store.dispatch(new fromStore.IgnoreSecurityIssue({
            websiteId: this._childWebsiteId || this.website.id,
            issueData: {}
          }));
        }
        else {
          NotifierComponent.notify(new Notification(response.message, NotificationType.DANGER));
        }
      });
  }

  public restoreIssue(ignoredIssue: SecurityIgnoredIssue): void {
    this.restoringIssueIds.push(ignoredIssue.id);

    this._securityService.restoreIssue(this._childWebsiteId || this.website.id, ignoredIssue.id)
    .pipe(filter((response: DbResponse): boolean => !!response),
      first())
      .subscribe((response: DbResponse): void => {
        if (this.restoringIssueIds.includes(ignoredIssue.id)) {
          this.restoringIssueIds.splice(this.restoringIssueIds.indexOf(ignoredIssue.id), 1);
        }

        if (response.success) {
          this._store.dispatch(new fromStore.RestoreSecurityIssue({
            websiteId: this._childWebsiteId || this.website.id,
            issueData: {}
          }));
        }
        else {
          NotifierComponent.notify(new Notification(response.message, NotificationType.DANGER));
        }
      });
  }

  private updateSettings(): void {
    this._store.dispatch(new fromStore.UpdateSecuritySettings({
      websiteId: this._childWebsiteId || this.website.id,
      settings: this.securitySettingsFg.value
    }));
  }
  private updateSettingsAutoupdate(): void {
    this.securityAutoupdateLoading = true;
    this._store.dispatch(new fromStore.UpdateSecurityAutoupdate({
      websiteId: this._childWebsiteId || this.website.id,
      securityAutoupdate: this.autoUpdateProductsFc
    }));
  }

  private updateSchedule(data): void {
    this.securityScheduleLoading = true;
    this._securityService.updateSecuritySchedule(this._childWebsiteId || this.website.id, data)
    .pipe(filter((response: DbResponse): boolean => !!response),
      first())
      .subscribe((response: DbResponse): void => {
        if (response.success) {
          new securityAction.LoadSecuritySchedule(this._childWebsiteId || this.website.id);
          NotifierComponent.notify(new Notification("Successfully saved", NotificationType.SUCCESS));
          this._store.dispatch(new fromStore.LoadSecuritySchedule(this._childWebsiteId || this.website.id));
        }
        else {
          NotifierComponent.notify(new Notification(response.message, NotificationType.DANGER));
        }
        this.securityScheduleLoading = false;
      });
  }
  public installAndActivate(): void {
    let network = 0;
    if (this.website.isNetwork || (!this.website.isNetwork && this.website.parentId)) {
      network = 1;
    }
    this._store.dispatch(new fromStore.InitWebsiteProductAction({
      website: this._childWebsiteId || this.website,
      products: [this.securityPlugin],
      action: ActivityAction.INSTALL_ACTIVATE,
      network: network
    }));
  }

  public activate(): void {
    let network = 0;
    if (this.website.isNetwork || (!this.website.isNetwork && this.website.parentId)) {
      network = 1;
    }
    this._store.dispatch(new fromStore.InitWebsiteProductAction({
      website: this._childWebsiteId || this.website,
      products: [this.securityPlugin],
      action: ActivityAction.ACTIVATE,
      network: network
    }));
  }

  public issueTrackBy(index: number, securityIssue: SecurityIssue) {
    return securityIssue.file_path;
  }

  public ignoredIssueTrackBy(index: number, ignoredIssue: SecurityIgnoredIssue) {
    return ignoredIssue.id;
  }


  public onSettingsSubmit(): void {
    const data = {
      schedule: this.scheduleEnabled,
      expression: this.scheduleCronExpression
    };
    this.updateSchedule(data);
  }

  public generateScheduleData(cronExpressionString): void {
    this.scheduleCronExpression = cronExpressionString;
  }

  public toggleAllItemsSelected(selected: boolean): void {
    switch (this.activeTab.value) {
      case 'issues':
        this.securityIssues.forEach((issue: SecurityIssue): void => {
          issue.selected = selected;
        });
        break;
      case 'ignoredIssues':
        this.securityIgnoredIssues.forEach((issue: SecurityIgnoredIssue): void => {
          issue.selected = selected;
        });
        break;
    }

  }

  private updateSelectAllState(type): void {
    switch (type) {
      case 'issues':
        this.selectAll.setValue(!this.securityIssues.find((issue: SecurityIssue): boolean => !issue.selected));
        break;
      case 'ignoredIssues':
        this.selectAll.setValue(!this.securityIgnoredIssues.find((issue: SecurityIgnoredIssue): boolean => !issue.selected));
        break;
    }
  }

  public get selectedIssues(): SecurityIssue[] {
    if (!this.securityIssues) {
      return [];
    }

    return this.securityIssues.filter((issue: SecurityIssue): boolean => {
      return issue.selected;
    });
  }

  public get selectedIgnoredIssues(): SecurityIgnoredIssue[] {
    if (!this.securityIgnoredIssues) {
      return [];
    }

    return this.securityIgnoredIssues.filter((issue: SecurityIgnoredIssue): boolean => {
      return issue.selected;
    });
  }

  public bulkIgnore() {
    this.bulkIgnoreLoading = true;
    this._securityService.bulkIgnoreIssue(this._childWebsiteId || this.website.id, this.selectedIssues)
    .pipe(filter((response: DbResponse): boolean => !!response),
      first())
      .subscribe((response: DbResponse): void => {
        if (response.success) {
          this._store.dispatch(new fromStore.LoadSecurityIgnoredIssues(this._childWebsiteId || this.website.id));
          this._store.dispatch(new fromStore.LoadSecurityScan(this._childWebsiteId || this.website.id));
        }
        else {
          NotifierComponent.notify(new Notification(response.message, NotificationType.DANGER));
        }
        this.bulkIgnoreLoading = false;
      });
  }

  public bulkRestore() {
    this.bulkRestoreLoading = true;
    this._securityService.bulkRestoreIssue(this._childWebsiteId || this.website.id, this.selectedIgnoredIssues)
    .pipe(filter((response: DbResponse): boolean => !!response),
      first())
      .subscribe((response: DbResponse): void => {
        if (response.success) {
          this._store.dispatch(new fromStore.LoadSecurityIgnoredIssues(this._childWebsiteId || this.website.id));
          this._store.dispatch(new fromStore.LoadSecurityScan(this._childWebsiteId || this.website.id));
        }
        else {
          NotifierComponent.notify(new Notification(response.message, NotificationType.DANGER));
        }
        this.bulkRestoreLoading = false;
      });
  }

  public onItemToggled($event): void {
    this.updateSelectAllState($event);
  }

}
